import { Reducer } from '@reduxjs/toolkit';

const appGlobalsReducer: Reducer = (state, { payload }) => {
  if (!state) {
    return { globals: null };
  }

  if (!payload) {
    return state;
  }

  return { ...state, globals: payload };
};

export default appGlobalsReducer;
